export const mediaQueries = {
  mobile: '(max-width: 767px)', // only needed for JS side
  tablet: '(min-width: 768px)',
  desktop: '(min-width: 1280px)',
};
